/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 10.01.13, 11:27
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { Localize } from "../utils/Localize";

import { AbstractTextContentVO } from "./AbstractTextContentVO";

/**
 *
 */
export class LocalizedTextVO extends AbstractTextContentVO {
    public static NAME: string = "LocalizedTextVO";
    private _textId: string;

    /**
     * Some textIds supports the possibility to insert values in predefined place holders.
     * Place holders are marked with braces like this: {0}, {1}, etc. and
     * will be maintained by the translators in the translation tool already.
     * The replacements are treated as <code>Array</code> and the order of the elements is important.
     *
     * <p>Example for textId "value_percentage" with the value: {0}%
     * To insert a numeric value into the {0} place holder configure e.g. your LocalizedTextVO like this:</p>
     *
     * <listing version="3.0">
     * new LocalizedTextVO("value_percentage",[10]);
     * </listing>
     */
    private _textReplacements: any;

    /**
     * Flag indicating whether numeric values residing in the textId inclusive the <code>_textReplacements</code>
     * should be localized with thousands separators and decimal mark.
     *
     * @see com.goodgamestudios.core.localization.processors.impl.flash.composer#localizeNumber()
     * @see com.goodgamestudios.core.localization.processors.impl.flash.composer#groupNumberLocalized()
     */
    private _groupNumber: boolean = false;

    constructor(textId: string = null, textReplacements: any = null, groupNumber: boolean = true) {
        super();

        this._textId = textId;
        this._textReplacements = textReplacements;
        this._groupNumber = groupNumber;
    }

    /**
     * String key for a localized text.
     *
     * <p>The<code>textId</code> key will be used to retrieve localized texts from the language files.
     * The language XML files are being created by the PHP based TranslationTool, see: http://translate.goodgamestudios.com
     *
     * <p>There are two categories of textIds: a generic and a game specific set.</p>
     *
     * <p>Example for a generic textId key: "generic_btn_close"</p>
     */

    public get textId(): string {
        return this._textId;
    }

    public set textId(value: string) {
        this._textId = value;
        this.propertyChangedSignal.dispatch();
    }

    public get textReplacements(): any {
        return this._textReplacements;
    }

    public set textReplacements(value: any) {
        this._textReplacements = value;
        this.propertyChangedSignal.dispatch();
    }

    public get groupNumber(): boolean {
        return this._groupNumber;
    }

    public set groupNumber(value: boolean) {
        this._groupNumber = value;

        this.propertyChangedSignal.dispatch();
    }

    public compose(): string {
        return Localize.text(this._textId, this._textReplacements, this._groupNumber);
    }

    public toString(): string {
        // tslint:disable-next-line:max-line-length
        return (
            LocalizedTextVO.NAME +
            ", textId: " +
            this._textId +
            ", textReplacements: " +
            this._textReplacements +
            ", groupNumber: " +
            this._groupNumber
        );
    }
}
